import { Injectable } from '@angular/core';
// import * as firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { Router } from '@angular/router';

@Injectable()
export class DetailsService {
  constructor(private afAuth: AngularFireAuth,
    private router: Router,
    private afs: AngularFirestore) { }

    async getpremiumlist() {
      try {
        return await this.afs.collection('PremiumList', res => {
          return res.orderBy('createdAt', 'desc');
        }).valueChanges();
      } catch (error) {
        console.log(error);
      }
    }
    async getSingleOrderDate(id) {
      try {
        const ids = parseInt(id)
        return await this.afs.collection('PremiumCollection', res => {
          return res.where('orderid', '==', ids);
        }).valueChanges();
      } catch (error) {
        console.log(error);
      }
    }
    getsingleuse(id) {
      return this.afs.doc('users/' + id).valueChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/service/details.service.ts